export default __webpack_public_path__ + "static/media/Байгууллагын_гүйцэтгэлийн_үнэлгээ.3cb53667.pdf";